import React, {useEffect, useState, useContext} from "react";
import PropTypes from "prop-types";
import TickerCard from "../../components/ticker/ticker-card/ticker-card";
import "./page.css";
import TickerGroup from "../../components/TickerComponents/TickerGroup/TickerGroup";
import AuthContext from "../../auth/auth-context";
import axios from 'axios'
import {format, set} from 'date-fns'

const Page = (props) => {
  // const { tickers } = props; // Ensure you have tickers passed as props
  const authCtx = useContext(AuthContext);

  const [tickers, setTickers] = useState([])
  const [timestamp, setTimestamp] = useState("")
  const [isError, setIsError] = useState(false)


  useEffect(() => {
    const fetchCurrencies = async () => {
      const headers = {
        "Acting-as": "dealer",
        Authorization: `JWT ${authCtx?.token}`,
      };

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/currency-rates/`, { headers: headers }
        );
        if (response.data) {
          let tickerCopy = [];
          const formatedData = response.data.results.map((currency) => {
            return {
              flag: currency.from_currency.alpha_2,
              currency: `${currency.from_currency.alpha_3}/${currency.to_currency.alpha_3}`,
              rate: currency.amount,
            };
          });
          tickerCopy.tickers = [...formatedData];
          tickerCopy.timestamp = format(response.data.results[0].created_at, "dd/MM/yyyy h:mm a");

          setTickers([...tickerCopy.tickers]);
          setTimestamp(tickerCopy.timestamp);

          // setTickers(response.data);
          // setTimestamp(response.data.timestamp);
          // setIsLoading(false);
        }
      } catch (error) {
        console.error("Error fetching currencies", error);
      }
    }
    fetchCurrencies();
}, [])

  return (
    <div id="page" className="default-page" style={{ width: props.sideBarOpen ? "calc(100% - 230px)" : "100%" }}>
          <div className="scroll-outer-container">
          <div className="scroll-container">
            <div className={`text-xs ticker_card_anchor m-0`}>
              <span className="timestamp-header">last updated:</span>
              <br />
              <span className="timestamp">
                {timestamp}
              </span>
            </div>
            <div className="scroller">
              {isError ? (
                <span className="text-sm text-white">{isError}</span>
              ) : (
                <div className="scroll_container">
                  <div className="flex flex-row w-full">
                    <TickerGroup
                      key="1"
                      groupName="Investec"
                      items={tickers}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          </div>
        
      <div className="widgets-container">{props.children}</div>
    </div>
  );
};

Page.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  sideBarOpen: PropTypes.bool,
  tickers: PropTypes.shape({
    tickers: PropTypes.array.isRequired,
  }).isRequired, // Added prop type for tickers
};

export default Page;